export const {
  customDomainAppCollection,
  enableRegistration,
  logins,
  sentryDsn,
  sentryEnvironment,
} = window.settings;
delete window.settings;
